export default __webpack_public_path__ + "static/media/gallery-11-3.aac19c75.jpg";